import LazyLoad from "vanilla-lazyload";
import { addBackToTop } from "vanilla-back-to-top";
// import get from "bootstrap-vue/esm/utils/get";

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN' : token.content
    };
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

let Site = function () {

    let lazyLoadInstance;

    let initMenu = function () {
        // Track the previous scroll position
        let lastScrollTop = 0;
        
        window.addEventListener("scroll", function () {
            let navbar = document.getElementById("nav");
            let navClasses = navbar.classList;
            let currentScrollTop = document.documentElement.scrollTop;
            
            // Determine scroll direction
            let scrollingDown = currentScrollTop > lastScrollTop;
            
            if (currentScrollTop >= 264) {
                if (!navClasses.contains("fixed")) {
                    navClasses.add("fixed");
                }
                
                // Add classes based on scroll direction
                if (scrollingDown) {
                    navClasses.add("scrolling-down");
                    navClasses.remove("scrolling-up");
                } else {
                    navClasses.add("scrolling-up");
                    navClasses.remove("scrolling-down");
                }
            }
            else {
                if (navClasses.contains("fixed")) {
                    navClasses.remove("fixed");
                    navClasses.remove("scrolling-down");
                    navClasses.remove("scrolling-up");
                }
            }
            
            // Update the last scroll position
            lastScrollTop = currentScrollTop;
        });
    };

    let initNavigation = function () {

        let classList = document.getElementById("koSidebar").classList;
        classList.toggle('d-none');

        document.getElementById("openNav").addEventListener("click", function () {
            let classList = document.getElementById("koSidebar").classList;
            classList.toggle('open');
        });

        document.getElementById("sidebarClose").addEventListener("click", function () {
            let classList = document.getElementById("koSidebar").classList;
            classList.toggle('open');
        });


    };

    let initBackToTop = function () {
        addBackToTop({
            diameter: 45,
            backgroundColor: '#f8e75a',
            textColor: 'black',
        });
    };

    let initLazyLoad = function () {
        if (typeof lazyLoadInstance !== 'undefined') {
            return lazyLoadInstance.update();
        }

        lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            load_delay: 100
        });
    };

    let initPagination = function () {
        window.addEventListener('scroll', function () {
            let height = document.documentElement.offsetHeight,
                offset = Math.ceil(document.documentElement.scrollTop + window.innerHeight);

            let wrapper = document.querySelector('#ajax-pagination');

            if (offset === height) {
                initCategoryPagination(wrapper);
                initCompetitionPagination(wrapper);
                initTagPagination(wrapper);
                initSortOrderPagination(wrapper);
            }
        });
    };

    let initTagPagination = function (wrapper) {

        let data = document.querySelector('.ajax-tag-pagination');

        if (typeof data == 'undefined' || data == null) {
            return;
        }

        let proceed = true;

        if (proceed) {
            let page = parseInt(data.dataset.page);
            let tagId = parseInt(data.dataset.tagId);
            let currentMenuItemId = parseInt(data.dataset.currentMenuItemId);
            console.log(page, tagId);
            proceed = false;

            if (typeof page == 'undefined') {
                return;
            }

            axios.post('/ajax/tag/paginate', {page, tagId, currentMenuItemId})
            .then(function(result) {
                wrapper.insertAdjacentHTML('beforeend', result.data.html);
                initLazyLoad();
                proceed = true;
                console.log(result.data.page);
                data.setAttribute('data-page', result.data.page);
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    };

    let initCategoryPagination = function (wrapper) {

        let data = document.querySelector('.ajax-pagination');

        if (typeof data == 'undefined' || data == null) {
            return;
        }

        let proceed = true;

        if (proceed) {
            let categoryId = data.dataset.categoryId;
            let currentMenuItemId = data.dataset.currentMenuItemId;
            let page = data.dataset.page;
            console.log(categoryId, currentMenuItemId, page);
            proceed = false;

            if (typeof page == 'undefined') {
                return;
            }

            axios.post('/ajax/category/paginate', {
                categoryId,
                currentMenuItemId,
                page
            })
            .then(function(result) {
                wrapper.insertAdjacentHTML('beforeend', result.data.html);
                // wrapper.innerHTML = result.data.html;
                initLazyLoad();
                proceed = true;
                console.log(result.data.page);
                data.setAttribute('data-category-id', result.data.categoryId);
                data.setAttribute('data-current-menu-item-id', result.data.currentMenuItemId);
                data.setAttribute('data-page', result.data.page);
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    };

    let initSortOrderPagination = function (wrapper) {

        let data = document.querySelector('.ajax-bookauthor-pagination');

        if (typeof data == 'undefined' || data == null) {
            return;
        }

        let proceed = true;

        if (proceed) {
            let categoryId = data.dataset.categoryId;
            let currentMenuItemId = data.dataset.currentMenuItemId;
            let page = data.dataset.page;
            console.log(categoryId, currentMenuItemId, page);
            proceed = false;

            if (typeof page == 'undefined') {
                return;
            }

            axios.post('/ajax/bookauthor/paginate', {
                categoryId,
                currentMenuItemId,
                page
            })
            .then(function(result) {
                wrapper.insertAdjacentHTML('beforeend', result.data.html);
                // wrapper.innerHTML = result.data.html;
                initLazyLoad();
                proceed = true;
                console.log(result.data.page);
                data.setAttribute('data-category-id', result.data.categoryId);
                data.setAttribute('data-current-menu-item-id', result.data.currentMenuItemId);
                data.setAttribute('data-page', result.data.page);
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    };

    let initCompetitionPagination = function (wrapper) {

        let data = document.querySelector('.ajax-competition-pagination');

        if (typeof data == 'undefined' || data == null) {
            return;
        }

        let proceed = true;

        if (proceed) {
            let categoryId = data.dataset.categoryId;
            let currentMenuItemId = data.dataset.currentMenuItemId;
            let page = data.dataset.page;
            console.log(categoryId, currentMenuItemId, page);
            proceed = false;
            let tpl = 'competition';

            if (typeof page == 'undefined') {
                return;
            }

            axios.post('/ajax/category/paginate', {
                categoryId,
                currentMenuItemId,
                page,
                tpl
            })
                .then(function(result) {
                    wrapper.insertAdjacentHTML('beforeend', result.data.html);
                    // wrapper.innerHTML = result.data.html;
                    initLazyLoad();
                    proceed = true;
                    console.log(result.data.page);
                    data.setAttribute('data-category-id', result.data.categoryId);
                    data.setAttribute('data-current-menu-item-id', result.data.currentMenuItemId);
                    data.setAttribute('data-page', result.data.page);
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    };

    return {
        //main function to initiate the module
        init: function () {
            initLazyLoad();
            initMenu();
            initNavigation();
            initBackToTop();
            initPagination();
        },
    };

}();

Site.init();
// window.addEventListener("load", function (event) {
// });
